import React, { useState, useCallback } from 'react';
import { useHistory } from 'react-router';
import { forgotPassword } from '../../../services/authServices';
import Button from '../../../component/button';
import { isDev } from '../../../helpers/common';
import AppLogo from '../../../component/appLogo';
import {
  Content,
  Form,
  FormBlock,
  FormText,
  FormText1,
  FormTextArea,
  FormView,
  Group,
  Icon,
  InputValue,
  Title,
  Viewer,
  ResetView
} from '../styles';
import LayoutWithoutNavbar from '../../../component/layoutWithoutNavbar';
import { BUTTON_TYPE } from '../../../global/constants';
import { rootStore } from '../../../mobx/rootStore';
import { observer } from 'mobx-react-lite';
import { ROUTES } from '../../../routes/urls';

const ForgotPassword: React.FC = () => {
  //States
  const [email, setEmail] = useState('');
  const [isSent, setIsSent] = useState(false);

  //mobx variable
  const { appStore } = rootStore;
  const { authLoading } = appStore;

  //Other variable
  const history = useHistory();

  // for email change
  const onChangeEmail = useCallback((value: string) => {
    setEmail(value);
  }, []);

  // for sending mail
  const onSendMail = useCallback(
    async (e: React.SyntheticEvent) => {
      e.preventDefault();
      const payload = {
        email,
        isDev: isDev()
      };
      const result = await forgotPassword(payload);
      if (result) {
        setEmail('');
        setIsSent(true);
      }
    },
    [email]
  );

  return (
    <>
      <LayoutWithoutNavbar>
        <Group isForgotPasswordPage className='windows-onboarding-flow'>
          <Content isSent={isSent}>
            <Icon>
              <AppLogo height={60} />
            </Icon>

            {isSent ? <></> : <Title> Forgot Password</Title>}
            {isSent ? (
              <>
                <ResetView>
                  <Title> Forgot Password Confirmation</Title>
                  <FormText isForgotPasswordSent={isSent}>
                    We have sent you an email with instructions on how to reset your password.
                  </FormText>
                </ResetView>
                <Button
                  title='Go Back to Log in'
                  variant={BUTTON_TYPE.PRIMARY}
                  onClick={() => {
                    history.push(ROUTES.LOGIN);
                  }}
                />
              </>
            ) : (
              <FormView>
                <Form onSubmit={onSendMail}>
                  <FormBlock>
                    <InputValue
                      typeof='email'
                      placeholder='Email Address'
                      value={email}
                      onChange={(e) => {
                        onChangeEmail(e.target.value);
                      }}
                    />
                  </FormBlock>
                  <Button
                    title='Send to mail'
                    variant={BUTTON_TYPE.PRIMARY}
                    buttonType='submit'
                    isLoading={authLoading}
                  />
                </Form>
                <FormTextArea>
                  <FormText isForgotPasswordSent={false}>Didn't receive the email?</FormText>
                  <FormText1>
                    <Viewer href='/membership/login'>Back to Login</Viewer>
                  </FormText1>
                </FormTextArea>
              </FormView>
            )}
          </Content>
        </Group>
      </LayoutWithoutNavbar>
    </>
  );
};

export default observer(ForgotPassword);
